module.exports = __webpack_public_path__ + "img/化工宝.cc8dead1.png";